import React from "react";
import Icon from '../../icon';


type Props = {
  value: number;
  title: string;
  description: string;
  updateValue: (value: number) => void;
};

export const NumberPicker = ({
  value,
  title,
  description,
  updateValue,
}: Props) => {
  return (
    <div className={`semiboldFontFamily flex gap-2 justify-between`}>
      <div className="flex gap-2">
        <div>{title}</div>
        <div>{description}</div>
      </div>
      <div className={"flex gap-1 items-center"}>
        <div
          className={`rounded-full border border-[#EAEAF2] text-[color:var(--highlightedSecondaryColor,rgb(17,_55,_102))]  flex justify-center items-center w-8 h-8 ${value == 0 ? "" : null}`}
          onClick={() => updateValue(value - 1)}
        >
          <Icon icon="Minor" />
        </div>
        <div className="min-w-[16px] flex justify-center font-bold">{value}</div>
        <div className="rounded-full border border-[#EAEAF2] text-[color:var(--highlightedSecondaryColor,rgb(17,_55,_102))]  flex justify-center items-center w-8 h-8" onClick={() => updateValue(value + 1)}>
          <Icon icon="Plus" />
        </div>
      </div>
    </div>
  );
};
